
  import { VIcon } from 'vuetify/lib/components'
  import pwa from '~/mixins/pages/pwa'
  export default {
    name: 'ThemeStoresMobileAndroidRatingDisplay',
    components: {
      VIcon
    },
    mixins: [pwa],
    props: {
      ratingDistribution: {
        type: Object,
        default: () => ({
          5: 6500,
          4: 1800,
          3: 300,
          2: 50,
          1: 38
        })
      }
    },
    computed: {
      pwa() {
        return this.$store.state['banner-pwa'].pwa
      },
      sortedRatingDistribution() {
        let distribution = {
          5: 6500,
          4: 1800,
          3: 300,
          2: 50,
          1: 38
        }

        const overall = ~~this.pwa?.pwa_app_settings?.overall_ratings

        if (overall) {
          // reset distribution
          distribution = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 }

          if (overall === 5) {
            distribution[5] = 100000 // special case: only 5
          } else {
            // Give the "overall" rating the biggest number
            distribution[overall] = 100000

            // Fill the others with smaller values
            Object.keys(distribution).forEach(key => {
              const k = parseInt(key, 10)
              if (k !== overall) {
                distribution[k] = Math.floor(distribution[overall] / 100)
                // e.g. 1% of the main rating
              }
            })
          }
        }

        return Object.keys(distribution)
          .map(key => Number(key))
          .sort((a, b) => b - a)
          .map(rating => ({ rating, count: distribution[rating] }))
      }
    },
    methods: {
      getBarWidth(count) {
        const counts = Object.values(this.ratingDistribution || {})
        const maxCount = counts.length ? Math.max(...counts) : 0
        return maxCount ? (count / maxCount) * 100 : 0
      },
      getPartialFillWidth() {
        const decimal = this.pwa?.pwa_app_settings?.overall_ratings % 1
        return decimal * 100
      }
    }
  }
